import { Component, OnInit } from '@angular/core';
import { NgForm,FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslationType } from '../translationtype.model';
import { TranslationService } from '../translation.service';

@Component({
  selector: 'app-create-translation',
  templateUrl: './create-translation.component.html',
  styleUrls: ['./create-translation.component.css']
})
export class CreateTranslationComponent implements OnInit {
  public translationtypes: TranslationType[];
  translationTypeControl = new FormControl('', [Validators.required]);
 animalControl = new FormControl('', [Validators.required]);
  constructor(public translationService: TranslationService, public dialogRef: MatDialogRef<CreateTranslationComponent>) {

  }

  ngOnInit() {
    this.getAllTranslationTypes();
    this.resetForm();

  }
  resetForm(form?: NgForm) {
    if (form != null) {
      form.resetForm();
      this.translationService.translationData = {
        translationId: null,
        original: '',
        translated: '',
        translationTypeId: null,
        ignore: false
      };
    
    }
  }

  getAllTranslationTypes() {
    this.translationService.getTranslationTypes()
      .subscribe(result => {
        this.translationtypes = result
      }, error => console.error(error));
  }

  onSubmit(form: NgForm) {
    if (form.valid) {

      if (this.translationService.translationData.translationId == null) {
        this.translationService.addTranslation({
          translationId: 0,
          original: form.value.original,
          translated: form.value.translated,
          translationTypeId: this.translationTypeControl.value,
          ignore: false
        });
      }
      else {
        this.translationService.updateTranslaion({
          translationId: this.translationService.translationData.translationId,
          original: form.value.original,
          translated: form.value.translated,
          translationTypeId: form.value.translationtypeid,
          ignore: false
        });
      }
      this.onClose();
    }
    {
      return;
    }

  }
  onClose() {
    this.dialogRef.close();
  }

  onCancel() {
    this.translationService.onCancel();
    this.onClose();
  }
}


